import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import ICategory from "@/interfaces/product.category.interfaces";
import categoryService from "@/services/category.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetCategoriesReturn = RequestsBaseReturn<PaginatedResponse<ICategory> | null>;

export type UseGetCategoriesProps = RequestPagination;

type GetAllSwrParams = [string, number, number];

const useGetCategories = ({
  pageNumber,
  pageSize,
}: UseGetCategoriesProps): UseGetCategoriesReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<ICategory>, Error, GetAllSwrParams>(
    [SWR_KEYS.getCategories, pageNumber, pageSize],
    async ([, _pageNumber, _pageSize]) => {
      const response = await categoryService.getAll({
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      });

      if (response?.items) {
        const seen = new Set();
        const uniqueItems = response.items.filter((item: ICategory) => {
          const duplicate = seen.has(item.id);
          seen.add(item.id);
          return !duplicate;
        });

        return {
          ...response,
          items: uniqueItems,
          totalCount: uniqueItems.length,
        };
      }

      return response;
    },
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetCategories;
